import { getViewData } from '../../../modules/view-data';

const STEP_1_ROUTE_NAMES = ['location', 'map', 'details', 'features', 'type', 'size', 'access'].reduce((acc, val, i) => {
    acc[val] = i + 1;
    return acc;
}, {});

const STEP_2_ROUTE_NAMES = [
    'availability', 'notice', 'generating', 'calendar',
    'reminder', 'future-bookings', 'booking-type',
    'pricing', 'description', 'instructions',
].reduce((acc, val, i) => {
    acc[val] = i + 1;
    return acc;
}, {});

const STEP_3_ROUTE_NAMES = ['images', 'streetview', 'housekeeping'].reduce((acc, val, i) => {
    acc[val] = i + 1;
    return acc;
}, {});

const STEP_ROUTE_NAMES = {
    1: STEP_1_ROUTE_NAMES,
    2: STEP_2_ROUTE_NAMES,
    3: STEP_3_ROUTE_NAMES,
};

export const ROUTE_NAME_TO_STEP = Object.entries(STEP_ROUTE_NAMES)
    .map(([step, routeNameToStep]) => {
        const stepNum = Number(step);
        return Object.keys(routeNameToStep).reduce((acc, routeName) => {
            acc[routeName] = stepNum;
            return acc;
        }, {});
    })
    .reduce((acc, val) => ({...acc, ...val}), {});

const getCurrentStep = (forStep, activeStep, route) => {
    if (route && activeStep === forStep) {
        return STEP_ROUTE_NAMES[forStep][route.name] || 0;
    }
    return 1;
};

export default {
    /**
     * Return whether or not we're on the listing flow
     *
     * @returns {Boolean}
     */
    isListing() {
        return window.location.pathname.startsWith('/list-your-space');
    },

    isAddressEditable(state) {
        if (getViewData('user.admin', false)) {
            return true;
        }
        return !(state.data && state.data.listing_completed_at);
    },

    activeStep(state, getters, rootState) {
        if (rootState.route) {
            const routeName = rootState.route.name;
            return ROUTE_NAME_TO_STEP[routeName] || 1;
        }
        return 1;
    },

    // eslint-disable-next-line require-jsdoc-except/require-jsdoc
    spacePayoutFeePercentage(state) {
        return state.data && state.data.space_payout_fee_percentage;
    },

    currentStep1(state, getters, rootState) {
        return getCurrentStep(1, getters.activeStep, rootState.route);
    },

    currentStep2(state, getters, rootState) {
        return getCurrentStep(2, getters.activeStep, rootState.route);
    },

    currentStep3(state, getters, rootState) {
        return getCurrentStep(3, getters.activeStep, rootState.route);
    },

    step1Complete(state) {
        return state.data && (state.data.listing_progress || []).indexOf('access') >= 0;
    },

    step2Complete(state) {
        return state.data && (state.data.listing_progress || []).indexOf('instructions') >= 0;
    },

    step3Complete(state) {
        return state.data && (state.data.listing_progress || []).indexOf('housekeeping') >= 0;
    },

    steps(state, getters) {
        return {
            active_step: getters.activeStep,
            step_1: {
                number: 1,
                complete: getters.step1Complete,
                max_steps: 7,
                current_step: getters.currentStep1,
                text: 'start with the basics',
            },
            step_2: {
                number: 2,
                complete: getters.step2Complete,
                max_steps: 10,
                current_step: getters.currentStep2,
                text: 'get ready for drivers',
            },
            step_3: {
                number: 3,
                complete: getters.step3Complete,
                max_steps: 3,
                current_step: getters.currentStep3,
                text: 'what your space looks like',
            },
        };
    },
};
